// src/pages/Projects.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/App.css';

const Projects = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#19231F',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '50px',
      textAlign: 'center'
    }}>
      <h1 style={{
        fontFamily: 'Book Antiqua, Palatino, serif',
        fontStyle: 'italic',
        fontSize: '48px',
        color: '#9CACA6',
        marginBottom: '40px'
      }}>
        Coming soon.
      </h1>
      <Link
        to="/"
        style={{
          fontFamily: 'Book Antiqua, Palatino, serif',
          fontStyle: 'italic',
          fontSize: '18px',
          color: '#9CACA6',
          backgroundColor: '#000000',
          padding: '12px 24px',
          borderRadius: '25px',
          textDecoration: 'none',
          transition: 'opacity 0.3s ease'
        }}
        onMouseEnter={(e) => e.target.style.opacity = '0.7'}
        onMouseLeave={(e) => e.target.style.opacity = '1'}
      >
        ← Back
      </Link>
    </div>
  );
};

export default Projects;